<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CBjsdU/cover.jpeg?1684571222055" alt="This image is the cover for the book Santa's Last Gift, Dreamspun Desires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Santa's Last Gift, Dreamspun Desires
      </h1>
      <p class="bookDescription body article font2">
        <p>The greatest gift might be what they already have.</p> <p>After years away building his career, event planner Sebastian Chesnut returns to his small hometown of Fir Falls to reconnect with his mother, sister, and young nieces before his job takes him to London.</p> <p>He doesn't expect to find his high school boyfriend, Matty, has become a virtual member of Seb's family. Back then, Matty only offered a casual relationship, but Seb fell hard, and history is soon repeating itself. Seb’s afraid to hope for a second chance, no matter how much they’ve grown and despite the family they share. Instead, he focuses on creating a last perfect holiday, which won’t be easy with his sister’s ex planning to take the girls over Christmas.</p> <p>Seb and Matty might not know what to do about their feelings for each other, but one thing’s for sure—it won’t be Christmas without the kids. Can these star-crossed lovers pull off a holiday miracle?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandine Tomas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?83fd5244